// superadmin_bill_users_v1: SuperAdmin manage bill_users across all tenants
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SA = axios.create({ baseURL: window.location.origin });
const ROLES = ['owner', 'admin', 'accountant'];

export default function SuperAdminBillUsers({ token, isMobile }) {
  const [users, setUsers] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterTenant, setFilterTenant] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ tenant_id: '', email: '', password: '', name: '', role: 'admin' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [pwUser, setPwUser] = useState(null);
  const [newPw, setNewPw] = useState('');

  const hdr = { headers: { Authorization: 'Bearer ' + token } };

  const load = function () {
    setLoading(true);
    const q = filterTenant ? ('?tenant_id=' + filterTenant) : '';
    SA.get('/api/superadmin/bill-users' + q, hdr)
      .then(function (r) { setUsers(r.data || []); })
      .catch(function () { setUsers([]); })
      .finally(function () { setLoading(false); });
  };

  useEffect(function () {
    SA.get('/api/superadmin/tenants', hdr)
      .then(function (r) { setTenants((r.data || []).filter(function (t) { return t.has_bill_feature !== false; })); })
      .catch(function () {});
  }, []);

  useEffect(function () { load(); }, [filterTenant]);

  const openCreate = function () {
    setEditing(null);
    setForm({ tenant_id: filterTenant || (tenants[0] && tenants[0].id) || '', email: '', password: '', name: '', role: 'admin' });
    setError('');
    setShowForm(true);
  };

  const openEdit = function (u) {
    setEditing(u);
    setForm({ tenant_id: u.tenant_id, email: u.email, password: '', name: u.name, role: u.role });
    setError('');
    setShowForm(true);
  };

  const save = async function () {
    setError('');
    if (!editing) {
      if (!form.tenant_id || !form.email || !form.password || !form.name) { setError('กรอก tenant, email, password, name ให้ครบ'); return; }
      if (form.password.length < 6) { setError('รหัสผ่านอย่างน้อย 6 ตัว'); return; }
    } else {
      if (!form.name) { setError('กรอกชื่อ'); return; }
    }
    setSaving(true);
    try {
      if (editing) {
        await SA.put('/api/superadmin/bill-users/' + editing.id, { name: form.name, role: form.role }, hdr);
      } else {
        await SA.post('/api/superadmin/tenants/' + form.tenant_id + '/bill-users', { email: form.email, password: form.password, name: form.name, role: form.role }, hdr);
      }
      setShowForm(false);
      load();
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.error) || 'บันทึกไม่สำเร็จ');
    } finally {
      setSaving(false);
    }
  };

  const toggle = async function (u) {
    try { await SA.patch('/api/superadmin/bill-users/' + u.id + '/toggle', {}, hdr); load(); }
    catch (err) { alert((err.response && err.response.data && err.response.data.error) || 'อัปเดตไม่สำเร็จ'); }
  };

  const doResetPw = async function () {
    if (!newPw || newPw.length < 6) { alert('รหัสผ่านอย่างน้อย 6 ตัว'); return; }
    try {
      await SA.post('/api/superadmin/bill-users/' + pwUser.id + '/reset-password', { new_password: newPw }, hdr);
      alert('รีเซ็ตรหัสผ่านสำเร็จ — ผู้ใช้จะถูกบังคับ login ใหม่');
      setPwUser(null); setNewPw('');
    } catch (err) {
      alert((err.response && err.response.data && err.response.data.error) || 'รีเซ็ตไม่สำเร็จ');
    }
  };

  const card = { background: '#1e293b', borderRadius: 14, overflow: 'hidden', marginBottom: 24 };
  const th = { padding: '10px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: '#475569', textTransform: 'uppercase' };
  const td = { padding: '12px 16px', color: '#e2e8f0', fontSize: 13 };
  const btn = function (bg, c) { return { background: bg, color: c, border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontWeight: 600, fontSize: 12, marginRight: 6 }; };
  const inp = { width: '100%', padding: 10, borderRadius: 8, border: '1px solid #334155', background: '#0f172a', color: '#f1f5f9', fontSize: 14, marginTop: 4, marginBottom: 14, boxSizing: 'border-box' };
  const lbl = { fontSize: 12, color: '#94a3b8', fontWeight: 600 };

  const roleBadge = function (role) {
    var map = { owner: ['#f59e0b20', '#f59e0b'], admin: ['#0ea5e920', '#0ea5e9'], accountant: ['#a855f720', '#a855f7'] };
    var c = map[role] || ['#64748b20', '#94a3b8'];
    return <span style={{ background: c[0], color: c[1], borderRadius: 6, padding: '3px 10px', fontSize: 12, fontWeight: 600 }}>{role}</span>;
  };

  return (
    <div style={card}>
      <div style={{ padding: isMobile ? '14px 16px' : '16px 24px', borderBottom: '1px solid #0f172a', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
        <h2 style={{ margin: 0, fontSize: isMobile ? 14 : 15, fontWeight: 600, color: '#f1f5f9' }}>ผู้ใช้ระบบบิล ({users.length})</h2>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <select value={filterTenant} onChange={function (e) { setFilterTenant(e.target.value); }}
            style={{ padding: '7px 12px', borderRadius: 8, border: '1px solid #334155', background: '#0f172a', color: '#f1f5f9', fontSize: 13 }}>
            <option value="">ทุกบริษัท</option>
            {tenants.map(function (t) { return <option key={t.id} value={t.id}>{t.name}</option>; })}
          </select>
          <button onClick={openCreate} style={{ background: '#0ea5e9', color: '#fff', border: 'none', borderRadius: 8, padding: '7px 16px', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>+ สร้างผู้ใช้</button>
        </div>
      </div>

      {loading ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#475569' }}>กำลังโหลด...</div>
      ) : users.length === 0 ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#475569' }}>ไม่มีผู้ใช้</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#0f172a' }}>
                {['บริษัท', 'ชื่อ', 'อีเมล', 'บทบาท', 'สถานะ', 'เข้าใช้ล่าสุด', ''].map(function (h, i) {
                  return <th key={i} style={th}>{h}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {users.map(function (u) {
                return (
                  <tr key={u.id} style={{ borderTop: '1px solid #0f172a' }}>
                    <td style={Object.assign({}, td, { color: '#94a3b8' })}>{u.tenant_name}</td>
                    <td style={Object.assign({}, td, { fontWeight: 600, color: '#f1f5f9' })}>{u.name}</td>
                    <td style={Object.assign({}, td, { color: '#94a3b8' })}>{u.email}</td>
                    <td style={td}>{roleBadge(u.role)}</td>
                    <td style={td}>
                      <span style={{ color: u.is_active ? '#22c55e' : '#ef4444', fontWeight: 600, fontSize: 12 }}>
                        {u.is_active ? '● ใช้งาน' : '○ ปิด'}
                      </span>
                    </td>
                    <td style={Object.assign({}, td, { color: '#64748b', fontSize: 12 })}>
                      {u.last_login_at ? new Date(u.last_login_at).toLocaleDateString('th-TH') : '-'}
                    </td>
                    <td style={Object.assign({}, td, { whiteSpace: 'nowrap' })}>
                      <button onClick={function () { openEdit(u); }} style={btn('#33415540', '#cbd5e1')}>แก้ไข</button>
                      <button onClick={function () { toggle(u); }} style={btn(u.is_active ? '#ef444420' : '#22c55e20', u.is_active ? '#ef4444' : '#22c55e')}>{u.is_active ? 'ปิด' : 'เปิด'}</button>
                      <button onClick={function () { setPwUser(u); setNewPw(''); }} style={btn('#a855f720', '#a855f7')}>รหัสผ่าน</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {showForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }} onClick={function () { setShowForm(false); }}>
          <div onClick={function (e) { e.stopPropagation(); }} style={{ background: '#1e293b', borderRadius: 14, padding: 24, width: '100%', maxWidth: 400 }}>
            <h3 style={{ margin: '0 0 18px', color: '#f1f5f9', fontSize: 16 }}>{editing ? 'แก้ไขผู้ใช้' : 'สร้างผู้ใช้ใหม่'}</h3>
            {!editing && (
              <div>
                <div style={lbl}>บริษัท</div>
                <select value={form.tenant_id} onChange={function (e) { setForm(Object.assign({}, form, { tenant_id: e.target.value })); }} style={inp}>
                  <option value="">— เลือกบริษัท —</option>
                  {tenants.map(function (t) { return <option key={t.id} value={t.id}>{t.name}</option>; })}
                </select>
              </div>
            )}
            <div style={lbl}>ชื่อ</div>
            <input value={form.name} onChange={function (e) { setForm(Object.assign({}, form, { name: e.target.value })); }} style={inp} />
            <div style={lbl}>อีเมล</div>
            <input value={form.email} onChange={function (e) { setForm(Object.assign({}, form, { email: e.target.value })); }} type="email" disabled={!!editing} style={Object.assign({}, inp, editing ? { opacity: 0.5 } : {})} />
            {!editing && (
              <div>
                <div style={lbl}>รหัสผ่าน</div>
                <input value={form.password} onChange={function (e) { setForm(Object.assign({}, form, { password: e.target.value })); }} type="password" placeholder="อย่างน้อย 6 ตัว" style={inp} />
              </div>
            )}
            <div style={lbl}>บทบาท</div>
            <select value={form.role} onChange={function (e) { setForm(Object.assign({}, form, { role: e.target.value })); }} style={inp}>
              {ROLES.map(function (r) { return <option key={r} value={r}>{r}</option>; })}
            </select>
            {error && <div style={{ background: '#7f1d1d40', color: '#fca5a5', padding: 10, borderRadius: 8, fontSize: 13, marginBottom: 12 }}>⚠️ {error}</div>}
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={function () { setShowForm(false); }} disabled={saving} style={{ flex: 1, padding: 11, borderRadius: 8, border: '1px solid #334155', background: 'transparent', color: '#94a3b8', cursor: 'pointer', fontSize: 14 }}>ยกเลิก</button>
              <button onClick={save} disabled={saving} style={{ flex: 1, padding: 11, borderRadius: 8, border: 'none', background: saving ? '#0c4a6e' : '#0ea5e9', color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>{saving ? 'กำลังบันทึก...' : 'บันทึก'}</button>
            </div>
          </div>
        </div>
      )}

      {pwUser && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }} onClick={function () { setPwUser(null); }}>
          <div onClick={function (e) { e.stopPropagation(); }} style={{ background: '#1e293b', borderRadius: 14, padding: 24, width: '100%', maxWidth: 360 }}>
            <h3 style={{ margin: '0 0 6px', color: '#f1f5f9', fontSize: 16 }}>รีเซ็ตรหัสผ่าน</h3>
            <div style={{ color: '#94a3b8', fontSize: 13, marginBottom: 16 }}>{pwUser.name} ({pwUser.email})</div>
            <div style={lbl}>รหัสผ่านใหม่</div>
            <input value={newPw} onChange={function (e) { setNewPw(e.target.value); }} type="password" placeholder="อย่างน้อย 6 ตัว" style={inp} />
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={function () { setPwUser(null); }} style={{ flex: 1, padding: 11, borderRadius: 8, border: '1px solid #334155', background: 'transparent', color: '#94a3b8', cursor: 'pointer', fontSize: 14 }}>ยกเลิก</button>
              <button onClick={doResetPw} style={{ flex: 1, padding: 11, borderRadius: 8, border: 'none', background: '#a855f7', color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>รีเซ็ต</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
